export const medicationFilterConstant = {
    GET_SUCCESS: 'MEDICATION_FILTER_GET_SUCCESS',
    CHANGE: 'MEDICATION_CHANGE',
    CREATED: 'MEDICATION_FILTER_CREATED',
    IMPORT_SUCCESS: 'MEDICATION_FILTER_IMPORT_SUCCESS',
    DELETED: 'MEDICATION_FILTER_DELETED',
};
